<template>
  <div class="main_box" v-loading.fullscreen="loading">
    <div class="full_layout">
      <div class="feedbackBox">
        <div class="feedbackTab">
          <ul class="bids_tabs">
            <li @click="MsgTabs(1)" :class="msgTabs==1?'on':''">{{$t('base.positive')}} <span v-if="MsgCount.PositiveCount != 0">({{MsgCount.PositiveCount}})</span></li>
            <li @click="MsgTabs(2)" :class="msgTabs==2?'on':''">{{$t('base.negative')}} <span v-if="MsgCount.NegativeCount != 0">({{MsgCount.NegativeCount}})</span></li>
          </ul>
          <div class="watch_sort_status" v-if="memberType==2||userInfo.IsSeller">
            <el-select class="all_bids all_sort" v-model="Sort" @change="feedbackStatus">
              <el-option v-for="(item,index) in feedback_status" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div>
        <ul class="feedbackList">
          <li class="listHeader">
            <div class="product">{{$t('base.product')}}</div>
            <div class="feedback">{{$t('base.feedback')}}</div>
            <div class="name">{{$t('base.name')}}</div>
            <div class="time">{{$t('base.time')}}</div>
            <div class="operate">{{$t('base.operate')}}</div>
          </li>
          <li v-for="(item,index) in list" :key="index" v-if="resultTpye!=1">
            <div class="product"><div class="line_txt1">{{item.Title}}</div></div>
            <div class="feedback"><div class="line_txt1">{{item.AppraisalContent}}</div></div>
            <div class="name"><el-avatar class="avatar" :src="item.HeadPortrait"></el-avatar><div class="">{{setNameNum(item)}}</div><span class="isSeller_tag" :class="item.AppraisalType==1?'buyer':''"  v-if="memberType==2||userInfo.IsSeller">{{item.AppraisalType==1?'Buyer':'Seller'}}</span></div>
            <div class="time">{{item.CreateDate|setTime}}</div>
            <div class="operate">
              <span class="view" @click="dialog(item,'feedback')">{{$t('base.viewDetails')}}</span>
            </div>
          </li>
        </ul>
      </div>
      <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-if="resultTpye==1" />
      <list-pagination class="full_layout" :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' />
    </div>
    <!-- 评价详情弹框 feedback-->
    <get-feedback :title="dialogTitle" :dialogClass="dialogBox" :list="dialogList" :memberType='memberType' :domVisible='dislogType.feedback' :userInfo="userInfo" @closeDialog="closeDialog" v-if='dislogType.feedback' />
  </div>
</template>
<script>

import { getInfo, getTime } from "@/api/public";
import NOTN from "@/components/notnull.vue";
import ListPagination from '@/components/listpagination'
import GetFeedback from "@/components/dialog/feedback"; // 评价详情
import bus from '@/api/bus';
export default {
  name: '',
  components: { ListPagination,NOTN,GetFeedback },
  data() {
    return {
      list: [],
      userInfo: null,
      msgTabs: 1,
      MsgCount:{PositiveCount:0,NegativeCount:0},
      TotalCount: 0,
      pi: 1,
      ps: 60,
      Sort:'',
      memberid:"",//被查看方id
      memberType:1,//被查看方状态 1买家，2卖家
      show: false,
      loading:false,
      resultTpye:'',
      dialogBox: 'dialogBox',
      dialogVisible: false,
      dialogTitle: this.$t('base.feedbackDetail'),
      dialogList: '',
      dislogType: this.$enumInfo.dislogType,
      feedback_status:this.$enumInfo.feedback_status
    }
  },
  filters: {
    setTime(val) {
      return getTime(val, -8, 4, 'cn')
    },
  },
  created() {
    bus.$emit('headerTitle', this.$t('base.myfeedback'));
    this.memberType=this.$route.params.id&&this.$route.params.id!='buyer'?2:1
    this.memberid=this.$route.query.id
    this.userInfo = getInfo()
  },
  mounted() {
    if(this.$route.query.type==2){
        this.msgTabs=2
    }
    this.getInfo()
    this.getMyFeedback()
  },
  methods: {
    
    setNameNum(val){
      var data=val
      var name=data.RealName
      var num=14;
      let reg=new RegExp("[\\u4E00-\\u9FFF]+",'g')
      if(this.memberType!=2){
        name+=' ('+(data.SellFavorableCount+data.BuyFavorableCount)+')'
      }
      if(reg.test(name)){
        num=7
      }
      if(name.length>num){
        name=name.substring(0,num)+'...'
      }
      return name
    },
    // 弹窗开启
    dialog(obj, val, res) {
      let that = this;
      that.dislogType[val] = true;
      
            obj.memberid=this.memberid
      that.dialogList = JSON.parse(JSON.stringify(obj))
    },
    // 弹窗关闭
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
    },
    MsgTabs(val) {
      let that = this;
      that.pi = 1;
      that.ps = 60;
      that.msgTabs = val;
      this.getMyFeedback()
    },
    feedbackStatus(){
      this.getMyFeedback()
    },
    // 获取用户详情
    getUserDetail() {
      let that = this;
      let data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId }
      that.$get(this.$interface.GetUserDetail, data).then(res => {
        if (res.result != 0) {
          let data = res.data;
          console.log(data)
          //that.MsgCount={PositiveCount:(data.BuyFavorableCount+data.SellFavorableCount),NegativeCount:(data.BuyNegativeCount+data.SellNegativeCount)}
          that.MsgCount['PositiveCount']=data.BuyFavorableCount+data.SellFavorableCount
          that.MsgCount['NegativeCount']=data.BuyNegativeCount+data.SellNegativeCount
        }
      })
    },
    // 获取店铺详细 0:不刷新商品列表，1:刷新商品列表
    GetStoresList() {
      let that = this
      let data = { 'Id': this.memberid, 'MemberId': '' }
      if (that.userInfo != null) {
        data.MemberId = that.userInfo.MappingUserId
      }
      this.$get(this.$interface.GetStoreDetail, data).then(res => {
        console.log(res)
        if (res.result != 0) {
          let data = res.data;
          that.MsgCount['PositiveCount']=data.BuyFavorableCount+data.SellFavorableCount
          that.MsgCount['NegativeCount']=data.BuyNegativeCount+data.SellNegativeCount
        }
      })
    },
    //
    getInfo(){
      if(this.memberType==1){
        this.getUserDetail()
      }else{
        this.GetStoresList()
      }
    },
    // 获取信息列表
    getMyFeedback() {
      let that = this
      that.loading=true;
      let data = { operator_id: this.userInfo.MappingUserId, memberid:this.memberid, token: this.userInfo.ChineseToken, pageIndex: that.pi, pageSize: that.ps,AppraisalStatus:this.msgTabs,AppraisalType:this.Sort,QueryMemberid:''}
      if (that.userInfo != null) {
        data.QueryMemberid = that.userInfo.MappingUserId
      }
      this.$get(this.$interface.GetAppraisalList, data).then(res => {
        if (res.result != 0) {
            that.TotalCount = res.count;
          if(res.count==0){
            that.resultTpye=1
            that.list=''
          }else{
            that.resultTpye=''
            that.list = res.data
          }
      that.loading=false;
        }
        //console.log(res)
      })
      //MyNotificationForWeb
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.getMyFeedback();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.getMyFeedback();
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bids_tabs {
  height: 48px;
  line-height: 48px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  font-size: 16px;
  text-align: center;
  margin-top: 20px;
}

.bids_tabs li {
  line-height: 48px;
  border: 1px solid #e0e0e0;
  border-bottom: none;
  border-right: none;
  /*min-width: 180px;*/
  min-width: 100px;
  padding: 0 20px;
  cursor: pointer;
  box-sizing: border-box;
}

.bids_tabs li:last-child {
  border-right: 1px solid #f0f0f0;
}

.bids_tabs li.on {
  background-color: #5F6DAE;
  color: #fff;
}
  .feedbackBox{
    margin-top: 20px;
  }
  .feedbackList{
    margin-top: 30px;
  }
  .feedbackList li{
    display: flex;
    border-bottom: 1px solid #e0e0e0;
  }
  .feedbackList li.listHeader{
    background: #f7f7f7;
  }
  .feedbackList li>div{
    padding: 14px 12px;
  }
  .feedbackList li .product{
    width: 350px;
  }
  .feedbackList li .feedback{
    width: 350px;
  }
  .feedbackList li .name{
    width: 200px;
    display: flex;
    align-items: center;
  }

  .feedbackList li .name .avatar{
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
  .feedbackList li .name .isSeller_tag{
    display: inline-block;
    width: 40px;
    height: 18px;
    border-radius: 2px;
    background: #58A800;
    color: #fff;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    margin-left: 5px;
  }
  .feedbackList li .name .isSeller_tag.buyer{
    background: #5F6DAE;
  }
  .feedbackList li .time{
    width: 140px;
  }
  .feedbackList li .operate{
    width: 160px;
  }
  .feedbackList li .operate .view{
     cursor: pointer;
  }
  .feedbackList li .operate .view:hover{
    cursor: pointer;
    text-decoration: underline;
    color: #5F6DAE;
  }
  .feedbackTab{
    position: relative;
  }
  .feedbackTab .watch_sort_status{
    width: 85px;
    position: absolute;
    right: 0;
    top: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/feedback/index.vue